"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDisplaysDto = exports.UpdateDisplaysMetadataDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const types_1 = require("../../../types");
const approximate_daily_impressions_1 = require("./commons/approximate-daily-impressions");
const display_opacity_schedule_1 = require("./commons/display-opacity-schedule");
const display_schedule_1 = require("./commons/display-schedule");
const display_widget_1 = require("./commons/display-widget");
const create_display_dto_1 = require("./create-display.dto");
const normalizeAudienceStatsInput = (value) => {
    const normalized = (0, create_display_dto_1.normalizeNestedClassArrayInput)(value, create_display_dto_1.AudienceStatInputDto);
    return normalized === undefined && value !== undefined && value !== null && value !== ""
        ? value
        : normalized;
};
// --- 4. DTO PRINCIPAL ACTUALIZADO ---
class UpdateDisplaysMetadataDto {
    isLandscape;
}
exports.UpdateDisplaysMetadataDto = UpdateDisplaysMetadataDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysMetadataDto.prototype, "isLandscape", void 0);
class UpdateDisplaysDto {
    display_ids;
    owner; // Se mantiene opcional para permitir actualizaciones parciales
    audio;
    resolution_width;
    resolution_height;
    metadata;
    // --- NUEVO CAMPO PRICING ---
    pricing;
    autoaccept_media;
    category;
    ad_policies;
    interior;
    tags;
    exclusions;
    widget;
    schedule;
    opacity_schedule;
    display_time_zone;
    provider;
    standard_price;
    screensaver_url;
    screensaver_duration;
    standard_currency;
    private_only;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    audience_stats;
    media_types;
    internal_blacklist;
    show_qr_to_send_content;
    show_display_qr;
    show_media_qr;
    published;
    is_archived;
}
exports.UpdateDisplaysDto = UpdateDisplaysDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsNotEmpty)({ each: true }),
    __metadata("design:type", Array)
], UpdateDisplaysDto.prototype, "display_ids", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplaysDto.prototype, "owner", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "audio", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], UpdateDisplaysDto.prototype, "resolution_width", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], UpdateDisplaysDto.prototype, "resolution_height", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => UpdateDisplaysMetadataDto),
    __metadata("design:type", UpdateDisplaysMetadataDto)
], UpdateDisplaysDto.prototype, "metadata", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)()
    // Transformación robusta: Permite recibirlo como Objeto JSON o como String JSON (desde FormData)
    ,
    (0, class_transformer_1.Transform)(({ value }) => {
        if (typeof value === "string") {
            try {
                return (0, class_transformer_1.plainToInstance)(create_display_dto_1.DisplayPricingDto, JSON.parse(value));
            }
            catch {
                return value; // Deja que el validador falle si no es JSON válido
            }
        }
        return value;
    }),
    (0, class_transformer_1.Type)(() => create_display_dto_1.DisplayPricingDto),
    __metadata("design:type", create_display_dto_1.DisplayPricingDto)
], UpdateDisplaysDto.prototype, "pricing", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "autoaccept_media", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplaysDto.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_display_dto_1.AdPoliciesDto),
    (0, class_validator_1.ValidateIf)((o) => !!o.ad_policies),
    __metadata("design:type", create_display_dto_1.AdPoliciesDto)
], UpdateDisplaysDto.prototype, "ad_policies", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "interior", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplaysDto.prototype, "tags", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(types_1.DISPLAY_EXCLUSIONS, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplaysDto.prototype, "exclusions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => display_widget_1.Widget),
    __metadata("design:type", display_widget_1.Widget)
], UpdateDisplaysDto.prototype, "widget", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if (typeof value === "string") {
            try {
                return (0, class_transformer_1.plainToInstance)(display_schedule_1.DisplayScheduleDto, JSON.parse(value));
            }
            catch {
                return value;
            }
        }
        return value;
    }),
    (0, class_transformer_1.Type)(() => display_schedule_1.DisplayScheduleDto),
    __metadata("design:type", display_schedule_1.DisplayScheduleDto)
], UpdateDisplaysDto.prototype, "schedule", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if (typeof value === "string") {
            try {
                return (0, class_transformer_1.plainToInstance)(display_opacity_schedule_1.DisplayOpacityScheduleDto, JSON.parse(value));
            }
            catch {
                return value;
            }
        }
        return value;
    }),
    (0, class_transformer_1.Type)(() => display_opacity_schedule_1.DisplayOpacityScheduleDto),
    __metadata("design:type", display_opacity_schedule_1.DisplayOpacityScheduleDto)
], UpdateDisplaysDto.prototype, "opacity_schedule", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplaysDto.prototype, "display_time_zone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    __metadata("design:type", String)
], UpdateDisplaysDto.prototype, "provider", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], UpdateDisplaysDto.prototype, "standard_price", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplaysDto.prototype, "screensaver_url", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], UpdateDisplaysDto.prototype, "screensaver_duration", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplaysDto.prototype, "standard_currency", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "private_only", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => approximate_daily_impressions_1.ApproximateDailyImpressions)
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", approximate_daily_impressions_1.ApproximateDailyImpressions)
], UpdateDisplaysDto.prototype, "approximateDailyImpressions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => normalizeAudienceStatsInput(value)),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_display_dto_1.AudienceStatInputDto),
    __metadata("design:type", Array)
], UpdateDisplaysDto.prototype, "audience_stats", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplaysDto.prototype, "media_types", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplaysDto.prototype, "internal_blacklist", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "show_qr_to_send_content", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "show_display_qr", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "show_media_qr", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "published", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplaysDto.prototype, "is_archived", void 0);
